import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EnableUserDataImage from './EnableUserDataImage'

const copy = {
  overline: `Rights to access and rectification`,
  heading: `Enable user data collection with a single API`,
}
const boxes = [
  {
    headline: `Compile user data for access and portability requests`,
    content: `Enable a raw data integration or warehouse to organize data about a given user, so you can easily share it in a structured format if requested.`,
  },
  {
    headline: `Instantly rectify user data`,
    content: `Automatically update user profiles and traits in Segment and in downstream tools whenever new information is received.`,
  },
]

const EnableUserData: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionBase variant="2Col" copyVariant="narrow" sticky={true}>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Overline tag="h3" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
        <ColumnTrackWrapper>
          <ColumnTrack gap="medium">
            {boxes.map(({ headline, content }) => (
              <FeatureBoxBase alignment="left" key={headline}>
                <FeatureBox.Body>
                  <FeatureBox.Title>{headline}</FeatureBox.Title>
                  <FeatureBox.Text>{content}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </Section.Copy>
      <Section.Contents>
        <Section.Sticky>
          <ImageWrapper
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1,
              },
            }}
            viewport={{ once: true }}
          >
            <EnableUserDataImage />
          </ImageWrapper>
        </Section.Sticky>
      </Section.Contents>
    </SectionBase>
  )
}

export default EnableUserData

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

const ImageWrapper = styled(m.div)``
